// extracted by mini-css-extract-plugin
module.exports = {"main":"category-module--main--2eO94"};